var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7327 19.7931C11.0326 20.0788 11.5074 20.0672 11.7931 19.7673C12.0788 19.4674 12.0672 18.9926 11.7673 18.7069L5.5159 12.7524L20.25 12.7524C20.6642 12.7524 21 12.4166 21 12.0024C21 11.5882 20.6642 11.2524 20.25 11.2524L5.5158 11.2524L11.7673 5.29765C12.0672 5.01195 12.0788 4.53715 11.7931 4.23725C11.5074 3.93735 11.0326 3.92575 10.7327 4.21145L3.3138 11.2782C3.1449 11.4391 3.0449 11.6444 3.0139 11.8577C3.0048 11.9044 3 11.9528 3 12.0024C3 12.0519 3.0048 12.1004 3.014 12.1473C3.045 12.3605 3.145 12.5656 3.3138 12.7264L10.7327 19.7931Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.8be835c32fbdae6cfc771fd8bd8bc3e6.svg";
export { ForwardRef as ReactComponent };